import * as types from '../constants/ActionTypes';

export const setPedido = pedido => dispatch => {
  dispatch({
    type: types.SET_PEDIDO,
    payload: {
      pedido,
    },
  });
};

export const reiniciarPedido = () => dispatch => {
  dispatch({
    type: types.REINICIAR_PEDIDO,
  });
};
